import { render, staticRenderFns } from "./pushRemarkModal.vue?vue&type=template&id=c8ad19f2&scoped=true&"
import script from "./pushRemarkModal.vue?vue&type=script&lang=js&"
export * from "./pushRemarkModal.vue?vue&type=script&lang=js&"
import style0 from "./pushRemarkModal.vue?vue&type=style&index=0&id=c8ad19f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ad19f2",
  null
  
)

export default component.exports